/** 能力値の補正（docs/03_simulation.md 3 章） */
import { LUCK, STAMINA, STAT_RANGE } from '../../config/balance';
import type { Rng } from '../../core/rng';
import type { Stats } from '../types';

/** v=1 で 1−range、v=10 で 1+range */
export function statFactor(v: number, range: number): number {
  return 1 + (range * (v - 5.5)) / 4.5;
}

/** v=1 で lo、v=10 で hi */
export function statLerp(v: number, lo: number, hi: number): number {
  return lo + ((hi - lo) * (v - 1)) / 9;
}

export const uphillFactor = (s: Stats): number => statFactor(s.physical, STAT_RANGE.uphill);
export const flatDownFactor = (s: Stats): number => statFactor(s.run, STAT_RANGE.flatDown);
export const staminaUseFactor = (s: Stats): number => 1 / statFactor(s.physical, STAT_RANGE.staminaUse);
export const downStaminaFactor = (s: Stats): number => 1 / statFactor(s.run, STAT_RANGE.downStamina);
export const nightRecoveryFactor = (s: Stats): number => statFactor(s.physical, STAT_RANGE.nightRecovery);
export const sinkFactor = (s: Stats): number => statFactor(s.glider, STAT_RANGE.sink);
export const prepPackFactor = (s: Stats): number => 1 / statFactor(s.glider, STAT_RANGE.prepPack);
/** 悪天候のペナルティの軽減率（0〜0.5） */
export const weatherMitigation = (s: Stats): number => statLerp(s.mental, 0, 0.5);

export function staminaSpeedFactor(stamina: number): number {
  if (stamina < STAMINA.veryLowThreshold) return STAMINA.veryLowFactor;
  if (stamina < STAMINA.lowThreshold) return STAMINA.lowFactor;
  return 1;
}

/** 不利な判定を振り直す（運）。bad=true の結果が出たら、確率 reroll でもう一度判定する */
export function rollWithLuck(rng: Rng, s: Stats, pBad: number): boolean {
  const bad = rng.chance(pBad);
  if (!bad) return false;
  if (rng.chance(statLerp(s.luck, 0, LUCK.maxReroll))) return rng.chance(pBad);
  return true;
}
